import useAxiosInterceptor from 'src/services/interceptor';
import { signingPin, ACCOUNT_PASSWORD_HEADER, SIGNING_PIN_HEADER } from '../constants';

//  THIN-7681 signature validation. Backend base path is /api/provider/signing-pin
//  (the interceptor base URL already includes /api). Verification happens on the sign
//  path (SignatureController), not here — this service only manages the PIN itself.
//
//  THIN-7775: the PIN goes in the SIGNING_PIN_HEADER header, never a query param. Query strings
//  land in ALB access logs, Datadog APM http.url, browser history and the Referer header, so
//  a ?pin= would leak the raw PIN across the logging fleet (THIN-7694 AC7).
class SigningPinService {
  private axiosInstance;

  constructor() {
    this.axiosInstance = useAxiosInterceptor();
  }

  getStatus = () => {
    return this.axiosInstance.get(signingPin.status);
  };

  setupPin = (pin: string) => {
    return this.axiosInstance.post(signingPin.setup, null, {
      headers: { [SIGNING_PIN_HEADER]: pin },
    });
  };

  //  APIT-656: the reset is gated on the account password. It rides in its own header for the
  //  same reason the PIN does — never a query param, never a body we might log. provider-service
  //  binds it `required = false`, and verifyForPasswordChange no-ops for accounts with no
  //  Keycloak-local password, so an omitted header is a valid request rather than a 400. We only
  //  attach it when the user actually typed something: an empty header is not the same as absent.
  resetPin = (newPin: string, accountPassword?: string) => {
    return this.axiosInstance.post(signingPin.reset, null, {
      headers: {
        [SIGNING_PIN_HEADER]: newPin,
        ...(accountPassword ? { [ACCOUNT_PASSWORD_HEADER]: accountPassword } : {}),
      },
    });
  };
}

const signingPinService = new SigningPinService();

Object.freeze(signingPinService);

export default signingPinService;
